import {
  INQUIRY_SHIPPER_GET_ALL_INQUIRIES,
  INQUIRY_SHIPPER_GET_STATUS_WISE_COUNT,
  INQUIRY_SHIPPER_GET_ALL_INQUIRIES_FETCH_ERROR,
  INQUIRY_SHIPPER_GET_ALL_INQUIRIES_ENABLE_LOADING,
  INQUIRY_SHIPPER_GET_ALL_INQUIRIES_DISABLE_LOADING,
  INQUIRY_SHIPPER_GET_ALL_INQUIRIES_SET_FILTERS,
  INQUIRY_SHIPPER_GET_ALL_INQUIRIES_APPLY_FILTERS,
  INQUIRY_SHIPPER_GET_ALL_INQUIRIES_SET_PAGINATION,
  INQUIRY_SHIPPER_GET_ALL_INQUIRIES_RESET_PAGINATION,
  INQUIRY_SHIPPER_SEARCH_ENABLE_LOADING,
  INQUIRY_SHIPPER_SEARCH_DISABLE_LOADING,
  INQUIRY_SHIPPER_SEARCH_SET_DATA,
  INQUIRY_SHIPPER_SEARCH_ERROR,
  INQUIRY_SHIPPER_GET_INQUIRY_DETAIL_ENABLE_LOADING,
  INQUIRY_SHIPPER_GET_INQUIRY_DETAIL_DISABLE_LOADING,
  INQUIRY_SHIPPER_INQUIRY_DETAIL_FETCH_ERROR,
  INQUIRY_SHIPPER_SET_INQUIRY_DETAIL_DATA,
  INQUIRY_SHIPPER_SET_INQUIRY_ID_FOR_DETAIL,
  INQUIRY_SHIPPER_GET_ALL_INQUIRIES_RESET_FILTERS,
  INQUIRY_SHIPPER_GET_ALL_INQUIRIES_SET_PREV_PAGINATION,
  SET_CREATE_INQUIRY_DATA,
  INQUIRY_SHIPPER_BIDS_RANKING_DATA,
  INQUIRY_SHIPPER_BIDS_RANKING_DATA_IS_LOADING,
  INQUIRY_SHIPPER_BOOKING_STAT_COUNTS_DATA_IS_LOADING,
  INQUIRY_SHIPPER_BOOKING_STAT_COUNTS_DATA,
  BULK_INQUIRY_CHECK_CHANGED,
} from './constants';

import {
  searchInquiryForShipperApi,
  fetchAllShipperEnquiries,
  fetchInquiryDetailsForShipper,
  fetchInquiryStatusWiseCountForShipper,
  getBidRanksShipperInquiry,
} from 'src/api/inquiry';
import { getLastSortedColumnValue } from 'src/utils/pagination';
import { getBookingStat } from 'src/api/booking';
import { InquiryStatus } from 'src/components/pages/Enquiry/InquiryUtils';
import { message } from 'antd';

export const searchInquiry = val => async (dispatch) => {
  dispatch({
    type: INQUIRY_SHIPPER_SEARCH_ENABLE_LOADING,
  });
  dispatch(loadSearchData(val));
  dispatch({
    type: INQUIRY_SHIPPER_SEARCH_DISABLE_LOADING,
  });
};
export const loadSearchData = val => async (dispatch) => {
  const response: any = await searchInquiryForShipperApi(val);
  if (response.isSuccess) {
    dispatch({
      type: INQUIRY_SHIPPER_SEARCH_SET_DATA,
      data: response.data,
    });
  } else {
    dispatch({
      type: INQUIRY_SHIPPER_SEARCH_ERROR,
      data: response.error,
    });
  }
};

export const getAllInquiriesApplyFilter = () => async (dispatch) => {
  dispatch({
    type: INQUIRY_SHIPPER_GET_ALL_INQUIRIES_APPLY_FILTERS,
  });
  // dispatch({
  //   type: INQUIRY_SHIPPER_GET_ALL_INQUIRIES_RESET_PAGINATION,
  // });
  dispatch(getAllInquires());
};

export const getAllInquiriesSetFilter = (val, applyFilter = false) => async (dispatch) => {
  dispatch({
    type: INQUIRY_SHIPPER_GET_ALL_INQUIRIES_SET_FILTERS,
    data: val,
  });
  if (applyFilter) {
    dispatch(getAllInquiriesApplyFilter());
  }
};

export const getAllInquiriesResetFilter = (apiCall = true) => async (dispatch) => {
  dispatch(
    {
      type: INQUIRY_SHIPPER_GET_ALL_INQUIRIES_RESET_FILTERS,
    });
  if (apiCall) dispatch(getAllInquires());
};

export const getAllInquiriesSetPagination = val => async (dispatch) => {
  dispatch({
    type: INQUIRY_SHIPPER_GET_ALL_INQUIRIES_SET_PAGINATION,
    data: val,
  });
  dispatch(getAllInquires());
};

export const getAllInquiriesResetPagination = () => async (dispatch) => {
  dispatch({
    type: INQUIRY_SHIPPER_GET_ALL_INQUIRIES_RESET_PAGINATION,
  });
  dispatch(getAllInquires());
};

export const getAllInquires = () => async (dispatch, getState) => {
  dispatch({
      type: INQUIRY_SHIPPER_GET_ALL_INQUIRIES_ENABLE_LOADING,
  });

  dispatch({
    type: INQUIRY_SHIPPER_BIDS_RANKING_DATA_IS_LOADING,
    data: true
  });

  dispatch({
    type: INQUIRY_SHIPPER_BOOKING_STAT_COUNTS_DATA_IS_LOADING,
    data: true
  });

  const appliedFilters = getState().inquiryShipperReducer.appliedFilters;
  const polList = appliedFilters.polList?.length ? appliedFilters.polList.map(filter => filter.key) : [];
  const podList = appliedFilters.podList?.length ? appliedFilters.podList.map(filter => filter.key) : [];
  const originCountryList = appliedFilters.originCountryList?.length ?
    appliedFilters.originCountryList.map(filter => filter.key) : [];
  const destinationCountryList = appliedFilters.destinationCountryList?.length ?
    appliedFilters.destinationCountryList.map(filter => filter.key) : [];
  const internalReferenceNumberList = appliedFilters.internalReferenceNumberList ?
    appliedFilters.internalReferenceNumberList.map(filter => filter.label) : [];
  const typeList = appliedFilters.typeList ? appliedFilters.typeList : [];
  const modeList = appliedFilters.modeList ? appliedFilters.modeList : [];
  const status = appliedFilters.status ? appliedFilters.status : 'ALL';
  const inquiryIdList = appliedFilters.inquiryIdList ? appliedFilters.inquiryIdList : [];
  const descendingOrder = appliedFilters.descendingOrder;
  const accessTypeFilters = appliedFilters.accessTypeFilters ?
    appliedFilters.accessTypeFilters : [];
  const pagination = getState().inquiryShipperReducer.pagination;
  const shipperIds = appliedFilters.shipperIds?.length ? appliedFilters.shipperIds.map(filter => filter.key) : [];
  const customerIds = appliedFilters.customerIds?.length ? appliedFilters.customerIds.map(filter => filter.key) : [];
  const supplierIds = appliedFilters.supplierIds?.length ? appliedFilters.supplierIds.map(filter => filter.key) : [];

  const originCityList = appliedFilters?.originCityList?.length ? appliedFilters.originCityList.map(filter => filter.key) : [];
  const destinationCityList = appliedFilters?.destinationCityList?.length ? appliedFilters.destinationCityList.map(filter => filter.key) : [];

  const body = {
    ...appliedFilters,
    inquiryIdList,
    polList,
    internalReferenceNumberList,
    originCountryList,
    destinationCountryList,
    podList,
    typeList,
    modeList,
    status,
    descendingOrder,
    accessTypeFilters,
    polSearch: undefined,
    podSearch: undefined,
    sortBy: appliedFilters.sortBy,
    lastInquiryId : getLastColumnId(pagination),
    lastSortedColumnValue: getLastSortedColumnValue(pagination),
    currentPageNumber: pagination.currentPageNumber,
    resultPerPage: Number(pagination.resultPerPage),
    nextOrPrev: pagination.nextOrPrev,
    originCityList, 
    destinationCityList,
    shipperIds: shipperIds.length > 0 ? shipperIds : undefined,
    customerIds: customerIds.length > 0 ? customerIds : undefined,
    supplierIds: supplierIds.length > 0 ? supplierIds : undefined,
  };

  const startGetBidRanksAndBookingStats = async (response) => {
    if (!response.isSuccess) return;

    const inquiryData = response?.response?.data || [];
    const allInquiryIds = inquiryData.map(inquiry => inquiry.id);
    
    // Identify confirmed inquiries from status field (available in inquiry list response)
    const confirmedInquiryIds = inquiryData
      .filter(inquiry => inquiry.status === InquiryStatus.CONFIRMED)
      .map(inquiry => inquiry.id);

    if (allInquiryIds.length === 0) return;

    // Parallelize both API calls since we can identify confirmed inquiries from status field
    const [responseBids, statCountsResponse] = await Promise.all([
      getBidRanksShipperInquiry({ inquiryIdList: allInquiryIds }),
      confirmedInquiryIds.length > 0
        ? getBookingStat({ inquiryIdList: confirmedInquiryIds })
        : Promise.resolve({ isSuccess: true, data: {} }),
    ]);

    // Process bid ranking data
    if (responseBids.isSuccess) {
      const inquiryIdvsBidDataRankingMap = (responseBids?.data || [])?.reduce((acc, curr) => {
        if (curr?.inquiryId) {
          acc[curr.inquiryId] = [curr];
        }
        return acc;
      }, {});

      dispatch({
        type: INQUIRY_SHIPPER_BIDS_RANKING_DATA,
        data: inquiryIdvsBidDataRankingMap,
      });
    }

    dispatch({
      type: INQUIRY_SHIPPER_BIDS_RANKING_DATA_IS_LOADING,
      data: false,
    });

    // Process booking stats data
    if (statCountsResponse.isSuccess && confirmedInquiryIds.length > 0) {
      dispatch({
        type: INQUIRY_SHIPPER_BOOKING_STAT_COUNTS_DATA,
        data: statCountsResponse.data,
      });
    } else if (!statCountsResponse.isSuccess && 'errorMessage' in statCountsResponse) {
      message.error(statCountsResponse.errorMessage);
    }

    dispatch({
      type: INQUIRY_SHIPPER_BOOKING_STAT_COUNTS_DATA_IS_LOADING,
      data: false,
    });
  };
  

  const startFetchAllShipperEnquiries = async () => {
    const response: any = await fetchAllShipperEnquiries(body);
    if (response.isSuccess) {
      dispatch({
        type: INQUIRY_SHIPPER_GET_ALL_INQUIRIES,
        data: response.response,
      });
    } else {
      dispatch({
        type: INQUIRY_SHIPPER_GET_ALL_INQUIRIES_FETCH_ERROR,
      });
    }
    startGetBidRanksAndBookingStats(response);
    dispatch({
      type: INQUIRY_SHIPPER_GET_ALL_INQUIRIES_DISABLE_LOADING,
    });
  };

  const startFetchInquiryStatusWiseCountForShipper = async () => {
    const responseIC: any = await fetchInquiryStatusWiseCountForShipper({
      polList,
      internalReferenceNumberList,
      originCountryList,
      destinationCountryList,
      podList,
      accessTypeFilters,
      typeList: body.typeList,
      modeList: body.modeList,
      inquiryIdList: body.inquiryIdList,
      userIdList: body.userIdList,
      originCityList,
      destinationCityList,
      shipperIds: shipperIds.length > 0 ? shipperIds : undefined,
      customerIds: customerIds.length > 0 ? customerIds : undefined,
      supplierIds: supplierIds.length > 0 ? supplierIds : undefined,
    });
    if (responseIC.isSuccess) {
      dispatch({
        type: INQUIRY_SHIPPER_GET_STATUS_WISE_COUNT,
        data: responseIC.response,
      });
    }
  };

  startFetchAllShipperEnquiries();
  startFetchInquiryStatusWiseCountForShipper();



  
};

const getLastColumnId = (pagination) => {
  switch (pagination.nextOrPrev) {
    case 'prev':
      return pagination.lastItemIdPrev;
    case 'next':
      return pagination.lastItemIdNext;
    default:
      return null;
  }
};

export const setInquiryIDForDetail = id => async (dispatch) => {
  dispatch({
    type: INQUIRY_SHIPPER_SET_INQUIRY_ID_FOR_DETAIL,
    data: id,
  });
};

export const setPrevPagination = (callInquiries = true) => async(dispatch, getState) => {
  dispatch({
    type: INQUIRY_SHIPPER_GET_ALL_INQUIRIES_SET_PREV_PAGINATION,
  });
  if (callInquiries) dispatch(getAllInquires());
};

export const getInquiryDetail = id => async (dispatch, getState) => {
  dispatch({
    type: INQUIRY_SHIPPER_GET_INQUIRY_DETAIL_ENABLE_LOADING,
  });
  setInquiryIDForDetail(id);
  const inquiryId = getState().inquiryShipperReducer.inquiryId;
  const response: any = await fetchInquiryDetailsForShipper(inquiryId);
  if (response.isSuccess) {
    dispatch({
      type: INQUIRY_SHIPPER_SET_INQUIRY_DETAIL_DATA,
      data: response.data,
    });
  } else {
    dispatch({
      type: INQUIRY_SHIPPER_INQUIRY_DETAIL_FETCH_ERROR,
      data: response.error,
    });
  }
  dispatch({
    type: INQUIRY_SHIPPER_GET_INQUIRY_DETAIL_DISABLE_LOADING,
  });

};

export const setCreateInquiryData = val => async (dispatch) => {
  dispatch({
    type: SET_CREATE_INQUIRY_DATA,
    data: val,
  });
}

export const changeSelection = (items) => async (dispatch) => {
  dispatch({
    type: BULK_INQUIRY_CHECK_CHANGED,
    data: items,
  });
}